import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { userConfig } from '~/global-state/userConfig';

export const FEATURE_FLAGS = {
  allow_all_time_period: 'allow_all_time_period',
  hourly_as_consumed_mode_enabled: 'hourly_as_consumed_mode_enabled',
  dynamic_filters_disabled: 'dynamic_filters_disabled',
  synchronise_inventory_enabled: 'synchronise_inventory_enabled',
  pnl_and_valuation_enabled: 'pnl_and_valuation_enabled',
  allocations_pivot_table_enabled: 'allocations_pivot_table_enabled',
  deal_update_enabled: 'deal_update_enabled',
  demand_view_allocated_sub_national_region_breakdown: 'demand_view_allocated_sub_national_region_breakdown',
  new_deal_reconciliation_enabled: 'new_deal_reconciliation_enabled',
  new_deal_reconciliation_matching_attributes: 'new_deal_reconciliation_matching_attributes',
} as const;

export type FeatureFlag = keyof typeof FEATURE_FLAGS;

export function useFeatureFlag(flag: FeatureFlag, defaultValue = false) {
  const [{ featureFlags }] = useAtom(userConfig);
  const flagValue = featureFlags[flag];
  if (flagValue === true || flagValue === false) {
    return flagValue;
  }
  return defaultValue;
}

// Returns true if the feature flag is enabled and set to true or undefined
export function useFeatureFlagEnabledByDefault(flag: FeatureFlag) {
  return useFeatureFlag(flag, true);
}

export function useFeatureFlagRoute(flag: FeatureFlag, replaceRoute?: string) {
  const flagEnabled = useFeatureFlag(flag);

  const navigate = useNavigate();

  useEffect(() => {
    if (!flagEnabled) {
      navigate(replaceRoute ?? '/', { replace: true });
    }
  }, [flagEnabled, navigate, replaceRoute]);
}

export function useFeatureFlagRouteWhenEnabled(flag: FeatureFlag, replaceRoute?: string) {
  const flagEnabled = useFeatureFlag(flag);

  const navigate = useNavigate();

  useEffect(() => {
    if (flagEnabled) {
      navigate(replaceRoute ?? '/', { replace: true });
    }
  }, [flagEnabled, navigate, replaceRoute]);
}
